import { getErrorDescription } from "@draftkings/sportsbook-common-utils";
import { telemetry } from "../constants";
import { getNavigatorConnectionData, Tracker } from "../helpers";
export class BonusDetailsConnection {
    constructor(options) {
        this.subscribe = (query) => {
            this.subscriber = {
                onData: query.onData,
                onError: query.onError,
            };
            return {
                dispose: () => {
                    this.subscriber = undefined;
                },
                send: this.send,
            };
        };
        this.send = (message) => {
            if (this.subscriber) {
                const messageHandler = this.messagesMap[message.method];
                if (typeof messageHandler === "function") {
                    messageHandler(message.params);
                }
            }
        };
        this.getBonusDetailsById = (request) => {
            const start = performance.now();
            this.bonusDetailsClient.getBoostByBoostId(this.getSiteExperience(), request.playerBonusId)
                .then(response => {
                this.subscriber && this.subscriber.onData({
                    type: "getBonusDetailsById",
                    data: response
                });
            })
                .catch(error => {
                Tracker.getInstance().trackEvent(telemetry.network.getBoostByBoostId.exception, Object.assign({ Method: "getBoostByBoostId", ClientType: telemetry.clientType, traceTimeInMilliseconds: performance.now() - start, OriginalError: getErrorDescription(error), MyBetsVersion: telemetry.version }, getNavigatorConnectionData()));
                this.subscriber && this.subscriber.onError({
                    type: "getBonusDetailsById",
                    data: error,
                });
            });
        };
        this.subscriber = undefined;
        this.bonusDetailsClient = options.client;
        this.getSiteExperience = options.getSiteExperience;
        this.messagesMap = {
            getBonusDetailsById: this.getBonusDetailsById,
        };
    }
}
//# sourceMappingURL=BonusDetailsConnection.js.map